export default "__VITE_ASSET__59ea9512__"